import { Box, Typography, useTheme } from "@mui/material"
import React from "react"

function Organization({ organizationName }) {
  const theme = useTheme()
  return (
    <Box
      sx={{
        boxShadow: 3,
        borderRadius: "4px",
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        mr: 1,
        px: 3,
        py: 0.9
      }}
    >
      <Typography sx={{ whiteSpace: "nowrap" }}>
        سازمان:{" "}
        <Typography color='primary' variant='span' fontWeight={700}>
          {organizationName}
        </Typography>
      </Typography>
    </Box>
  )
}

export default Organization
